export default "__VITE_ASSET__6e443ab8__"